import { getItem, setItem } from '@growth/cookies';
import { C, g as generateVid } from '../../dist/helper-b7763bea.esm.js';
export { C as config, g as generateVid } from '../../dist/helper-b7763bea.esm.js';

var getVisitorIdBrowser = function getVisitorIdBrowser() {
  var vid = getItem(C.CookieName);
  if (vid && typeof window !== 'undefined' && !window.isDeviceIdUpdated) {
    window.isDeviceIdUpdated = true;
    setItem(C.CookieName, vid, {
      expires: C.MaxAgeDay * 24 * 60 * 60,
      path: '/',
      domain: C.Domain,
      secure: true
    });
  }
  return vid || undefined;
};
var visitorIdBrowser = function visitorIdBrowser(options) {
  var opts = options || {};

  // if vid already present, return the same
  var v = getVisitorIdBrowser();
  if (v) {
    if (opts.debug) console.info('DEBUG visitorIdBrowser: visitorId cookie is already present in browser');
    return v;
  }

  // set the vid and return the same
  var vid = generateVid();
  setItem(C.CookieName, vid, {
    expires: C.MaxAgeDay * 24 * 60 * 60,
    path: '/',
    domain: C.Domain,
    secure: true
  });
  if (opts.debug) console.info('DEBUG visitorIdBrowser: new visitorId cookie has been set to browser');
  return vid;
};

export { getVisitorIdBrowser, visitorIdBrowser };
